/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(Array)],
  props: {
    title: {
      type: String, default: ''
    },
    max: {
      type: Number, default: 1
    },
    tooltip: {
      type: String, default: ''
    }
  },
  emits:['blur'],
  data() {
    return {
      inputs_validity: Array(this.modelValue.length).fill(true)
    }
  },
  computed:{
    can_add() {
      return this.value.length < this.max && !this.value.includes('')
    },
    valid () {
      return this.inputs_validity.indexOf(false) == -1
    }
  },
  methods: { 
    addItem() {
      this.value.push('')
      this.inputs_validity.push('true')
    },
    removeItem(idx) {
      this.value.splice(idx, 1)
      this.inputs_validity.splice(idx, 1)
      this.$emit('blur')
    }
  }
}
